import Vue from 'vue'
import fixedOdds from '@/library/fixedOdds'
import lib from '@/library'

const actions = {
  getTeaserOptions (context, selection) {
    console.log('getTeaserOptions')
    //
    /*
    setTimeout(function () {
      context.dispatch('getTeaserGroups')
    }, 1)
    */
    //
    var id = selection.idfoselection
    var pricetypes = {'T1': 1, 'T2': 1, 'T3': 1}
    var market = context.state.markets[selection.idfoselection]
    var fetch = true

    if (context.state.teaserSports.indexOf(market.idfosporttype) > -1) {
      /*
      if (!context.getters.allowInPlayTeasers) {
        fetch = !context.getters.isSelectionLive(selection.idfoselection)
      }
      */
      //
      if (fetch) {
        for (var i in pricetypes) {
          context.dispatch('getTeaser', {pricetype: i, id: id})
        }
      }
    }
  },

  getTeaser (context, data) {
    // console.log('getTeaser')
    var pricetype = data.pricetype
    var id = data.id
    // console.log('Get Teaser ' + pricetype + ' for ' + id)
    lib.kansas.selectionsforpricetype({
      pricetype: pricetype,
      ids: id
    }).then(function (response) {
      var selection
      // console.log('teaserOptions response:')
      // console.log(response.data)
      if (response.data) {
        if (response.data.selections && response.data.selections.length) {
          selection = response.data.selections.find(function (s) {
            // return s.currentmatchhandicap && s.idfoselectionsource === id
            return s.idfoselectionsource === id
          })
          if (selection && selection.pricetypecsv === pricetype) {
            // console.log('Adding ' + id + ' to ' + selection.pricetypecsv)
            // selection.pricetype = 'FP'
            selection.pricetype = pricetype
            Vue.set(context.state.teasers.T[selection.pricetypecsv], id, selection)
            Vue.set(context.state.optedIn.TEASER, id, true)
          }
        }
      }
    }).catch(function (error) {
      window.console.log('getTeaser error:')
      window.console.log(error)
    })
  },

  getTeasers (context, data) {
    // console.log('getTeasers')
    var pricetype = data[0]
    var sport = data[1]
    var processed = []
    // var ids = context.state.betslipSelectionIds.join(',')
    var ids = context.getters.getTeaserSrcSelectionsBySportAndPricetype([sport, pricetype])
    return !!ids.length && ids.length > 1 && lib.kansas.selectionsforpricetype({
      pricetype: pricetype,
      ids: ids
    }).then(function (response) {
      if (response.data) {
        if (response.data.selections && response.data.selections.length) {
          response.data.selections.forEach(function (selection) {
            // selection.pricetype = 'FP'
            selection.pricetype = pricetype
            var index = processed.indexOf(selection.idfoselectionsource)
            if (index === -1) {
              processed.push(selection.idfoselectionsource)
              // if (selection.currentmatchhandicap) {
              Vue.set(context.state.teasers.T[selection.pricetypecsv], selection.idfoselectionsource, selection)
              // }
            }
          })
          return response.data.selections
        }
      }
    }).catch(function (error) {
      console.log('getTeasers error:')
      console.log(error)
      return []
    })
  },

  getAllowedBetTypesAndReturns4Teasers (context, ary) {
    // console.log('getAllowedBetTypesAndReturns4Teasers: ')
    var tab = 'TEASER'
    var sport = ary[0]
    var selections = ary[1]
    // var iDFOSportType = ary[2]
    var iDFOSportType = ary[0]
    // console.log('sport: ' + sport + '; iDFOSportType: ' + iDFOSportType)
    if (context.state.currentBetSlipState > 1) {
      return
    }
    if (selections.length > 1) {
      var allowedBetTypesAndReturnsSelectionsStr = ''
      selections.forEach(function (s) {
        allowedBetTypesAndReturnsSelectionsStr += s.idfoselection
      })
      if (!context.state.allowedBetTypesAndReturnsSelectionsCall[tab][iDFOSportType]) {
        Vue.set(context.state.allowedBetTypesAndReturnsSelectionsCall[tab], iDFOSportType, '')
      }
      var delta = allowedBetTypesAndReturnsSelectionsStr !== context.state.allowedBetTypesAndReturnsSelectionsCall[tab][iDFOSportType]
      //
      if (delta) {
        Vue.set(context.state.allowedBetTypesAndReturnsSelectionsCall[tab], iDFOSportType, allowedBetTypesAndReturnsSelectionsStr)
        // Vue.set(context.state, 'gettingABTnR4T', true)
        Vue.set(context.state, 'gettingABTnR', true)
        // context.commit('resetABTnR4Teaser', sport)
        // context.commit('resetAllowedBetTypesAndReturns')
        if (!context.state.requestId.abtnr.teasers[sport]) {
          Vue.set(context.state.requestId.abtnr.teasers, sport, 0)
        }
        context.state.requestId.abtnr.teasers[sport]++
        var rqId = context.state.requestId.abtnr.teasers[sport]
        return fixedOdds.getAllowedBetTypesAndReturns(selections, 'ABTnR4T-' + sport).then(
          function (r) {
            if (rqId !== context.state.requestId.abtnr.teasers[sport]) {
              // console.log('Missmatched request getAllowedBetTypesAndReturns4Teasers' + ' rqId: ' + rqId + ' <> ' + context.state.requestId.abtnr.teasers[sport])
              return
            }
            Vue.set(context.state.allowedBetTypesAndReturns.TEASER, sport, r.result)
            // Vue.set(context.state, 'gettingABTnR4T', false)
            Vue.set(context.state, 'gettingABTnR', false)
          }).catch(
          function (error) {
            console.log('failed to getAllowedBetTypesAndReturns for Teasers')
            console.log(error)
            // Vue.set(context.state, 'gettingABTnR4T', false)
            Vue.set(context.state, 'gettingABTnR', false)
          })
      }
    } else {
      Vue.set(context.state.allowedBetTypesAndReturnsSelectionsCall[tab], iDFOSportType, '')
      Vue.set(context.state, 'gettingABTnR', false)
      context.commit('resetABTnR4Teaser', sport)
    }
  },
  updateTeaser (context) {
    context.commit('doTeaserUpdate')
  },

  getTeaserGroups (context, selection) {
    // console.log('getTeaserGroups')
    // selection.idfosporttype
    if (selection && selection !== 'ALL' && selection.idfosporttype && context.state.teaserSports.indexOf(selection.idfosporttype) === -1) {
      // console.log('Not Teaser selection')
      return
    }
    if (context.state.tab !== 'TEASER') {
      Vue.set(context.state.teasers, 'pendingGetTeaserGroups', true)
      return
    }
    Vue.set(context.state.teasers, 'pendingGetTeaserGroups', false)
    // var tab = context.state.tab
    // var betslipSelectionIds = context.getters.betslipSelectionIds
    var betslipSelectionIds = context.getters.betslipSelections.filter(function (s) {
      return context.state.teaserSports.indexOf(s.idfosporttype) > -1
    }).map(function (e) {
      return e.idfoselection
    })
    context.state.requestId.allTeasers++
    var rqId = context.state.requestId.allTeasers
    //
    if (betslipSelectionIds.length) {
      var stakes = JSON.parse(JSON.stringify(context.state.betTypeStakes.TEASER))
      for (var i in context.state.teasers.teaserGroups) {
        var group = context.state.teasers.teaserGroups[i]
        if (group.Selections) {
          stakes[i].selections = stakes[i].selections || []
          group.Selections.forEach(function (s) {
            stakes[i].selections.push(s.IDFOSelection)
          })
        }
      }
      // console.log('stakes:')
      // console.log(stakes)
      //
      return fixedOdds.getTeasers(betslipSelectionIds).then(function (response) {
        // console.log('New getTeasers')
        if (rqId !== context.state.requestId.allTeasers) {
          console.log('Missmatched request getTeaserGroups' + ' rqId: ' + rqId + ' <> ' + context.state.requestId.allTeasers)
          return
        }
        // console.log(response)
        let tmpMixedArr = []
        let mixedGroup = {
          'IDFOSportType': 'MIXED',
          'Selections': [],
          'selectedTeaser': 'T1',
          'Sports': 'MIXED',
          'SportType': 'MIXED',
          'Spread1': 0,
          'Spread2': 0,
          'Spread3': 0,
          'iconName': '',
          'sportName': ''
        }
        let icons = []
        let sportNames = []
        if (response.result && response.result.Groups) {
          response.result.Groups.forEach(function (group, index) {
            // var groupId = context.getters.teaserGroupId(group)
            // console.log('groupId: ' + groupId)
            group.selectedTeaser = 'T1'
            //
            if (icons.indexOf(group.IDFOSportType) === -1) {
              icons.push(group.IDFOSportType)
            }
            //
            var sports = group.Sports.split(',')
            var sport = sports.length === 1 ? sports[0] : group.IDFOSportType
            if (sportNames.indexOf(sport) === -1) {
              sportNames.push(sport)
            }
            //
            var updatedStake = false
            for (var i in group.Selections) {
              if (!updatedStake) {
                Vue.delete(context.state.betTypeStakes.TEASER[index].PerBetType, 'A')
              }
              var id = group.Selections[i].IDFOSelection
              for (var s in stakes) {
                if (stakes && stakes[s] && stakes[s].selections && stakes[s].selections.indexOf(id) > -1) {
                  var stake = stakes[s].PerBetType.A
                  if (stake) {
                    updatedStake = true
                  }
                  Vue.set(context.state.betTypeStakes.TEASER[index].PerBetType, 'A', stake)
                  break
                }
              }
              for (var j = 1; j <= 3; j++) {
                var selection = group.Selections[i]['Item' + j]
                if (selection && selection.IDFOSelection) {
                  // var id = selection.IDFOSelection
                  // console.log('Adding ' + id + ' to ' + selection.PriceType)
                  // selection.pricetype = 'FP'
                  selection.idfoselectionsource = id
                  selection.pricetype = selection.PriceType
                  selection.hadvalue = selection.HADValue
                  selection.idfoselection = selection.IDFOSelection
                  selection.currenthandicap = selection.Handicap
                  selection.spread = selection.Spread
                  Vue.set(context.state.teasers.T[selection.pricetype], id, selection)
                  if (id in context.state.optedIn.TEASER) {
                  } else {
                    Vue.set(context.state.optedIn.TEASER, id, true)
                  }
                }
              }
              if (context.state.mixedTeasers) {
                // console.log('added to MIXED')
                tmpMixedArr.push(group.Selections[i])
              }
            }
          })
          //
          if (context.state.mixedTeasers) {
            betslipSelectionIds.forEach(function (id) {
              let s = tmpMixedArr.find(function (m) {
                return m.IDFOSelection === id
              })
              if (s) {
                mixedGroup.Selections.push(s)
              }
            })
            mixedGroup.iconName = icons.length === 1 ? icons[0] : ''
            mixedGroup.sportName = sportNames.length === 1 ? sportNames[0] : ''
          }
          //
          Vue.set(context.state.teasers, 'teaserGroups', context.state.mixedTeasers ? [mixedGroup] : response.result.Groups)
          //
          context.commit('doTeaserUpdate')
        }
      }).catch(function (error) {
        console.log('getTeaserGroups error:')
        console.log(error)
      })
    } else {
      Vue.set(context.state.teasers, 'teaserGroups', {})
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslip/actions/teasers.js